import React from "react"
import { Button as ShadcnButton } from "@/components/ui/button"
import type { ButtonProps as ShadcnButtonProps } from "@/components/ui/button"

export interface ButtonProps extends ShadcnButtonProps {
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link" | "gradient"
  color?: "primary" | "secondary" | "error" | "warning" | "info" | "success"
  size?: "default" | "sm" | "lg" | "icon"
}

export const Button: React.FC<ButtonProps> = ({
  variant = "default",
  color,
  className,
  ...props
}) => {
  // Map color props to variants if needed
  let finalVariant = variant
  if (color === "error" && variant === "default") {
    finalVariant = "destructive"
  } else if (color === "secondary" && variant === "default") {
    finalVariant = "secondary"
  }

  return (
    <ShadcnButton
      variant={finalVariant as any}
      className={className}
      {...props}
    />
  )
}

export default Button
